//
//
//
//
//
//
//
//
//

import { isEmpty } from 'lodash';

export default {
  name: 'JobSeeker',
  props: { jobPositionId: { type: String, default: '' } },
  data() {
    return {
      dataList: [],
      totalNum: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.dataList);
    },
  },
  methods: {
    getJobsApplicant() {
      const payload = {
        jobPositionId: this.jobPositionId,
        current: this.currentPage,
        size: this.pageSize,
        status: this.status,
      };

      this.$api('getOwnerJobsApplicant', payload).then(data => {
        this.dataList = data.records;
        this.totalNum = data.total;
      });
    },
  },
  mounted() {
    this.getJobsApplicant();
  },
};
